import React from 'react';
import {FormattedMessage} from 'react-intl';
import {Card} from 'antd';

import {VideoInstructionInterface} from 'components/VideoInstructions/types';

interface InstructionCardProps {
    instruction: VideoInstructionInterface;
    onOpen: (instruction: VideoInstructionInterface) => void;
}

const InstructionCard: React.FC<InstructionCardProps> = ({instruction, onOpen}) => (
    <Card
        hoverable
        className='instructions-card'
        onClick={() => onOpen(instruction)}
    >
        <img
            className='instructions-card-image'
            src={`https://img.youtube.com/vi/${instruction.videoCode}/maxresdefault.jpg`}
            alt=''
        />
        <div className='instruction-settings'>
            <span className='instruction-title'>
                {instruction.title.substring(0, 65)}
                <span>
                    {instruction.title.length > 65 ? '...' : null}
                </span>
            </span>

            <hr className='form-group-separator'/>

            {instruction.videoLength && (
                <span className='instruction-info'>
                    <i className='fal fa-clock'></i>
                    <span style={{marginRight: 5}}>
                        {instruction.videoLength}
                    </span>
                    <FormattedMessage id='general.minutes'/>
                </span>
            )}
        </div>
    </Card>
);

export default InstructionCard;
